export class ConcatModel {
  constructor(
    public target = '',
    public manipulation: { params: string[]; quillObject: unknown } = { params: [], quillObject: null }, // TODO: unknown?
    public manipulationType = 'Concat',
  ) {}
}
